<script>

// IMPORTS
import Items from '../stores/Items.js';

import Menu from './Menu.svelte';
import ItemList from "./ItemList.svelte";

import Fa from 'svelte-fa';
import { faPlus } from '@fortawesome/free-solid-svg-icons';


// ------------------------------------------------- //

// let's first check for a stored sequential ID
let currentID = JSON.parse(localStorage.getItem("currentID"));
// This is the item prototype to start off with
// We set the id to the one from localStorage or else to 0

export let todo = {
	id: currentID === null ? 0 : currentID,
	title: "",
	done: false,
	location: "",
	starts: "",
	ends: "",
	notes: "",
	isOpen: false,
};

// Add a new Item to the list
// addTodo is bound to the main input and syncs to the ItemStore (svelte store)
const addTodo = () => {
	todo.title = todo.title.trim();
	if (todo.title !== "") {
		Items.update(currentItems =>{
			// we can change the insert position of the new todo by swapping out the element and the spread array --> [...currentItems, todo]
			return [todo,...currentItems];
		})
	}
	resetDefaultTodo();
	todo.id++;
	// we synchronize the next id to localStorage 
	localStorage.setItem("currentID", JSON.stringify(todo.id));
}

// this reset empties the input and prepares for the next item
function resetDefaultTodo() {
	todo = {
		id: todo.id,
		title: "",
		done: false,
		location: "",
		starts: "",
		ends: "",
		notes: "",
		isOpen: false,
	}
}

</script>

<!-- THE HTML -->

<main>
	<Menu />
		<div id="list-wrapper">
			<form id="submit-form" on:submit|preventDefault={addTodo}>
				<input
					type="text"
					placeholder="New item"
					id="item-input"
					bind:value={todo.title}
				/>
				<button type="submit" id="add-btn"><Fa icon={faPlus}/></button>
			</form>
			<ItemList/> 
		</div>
</main>

<!-- THE CSS -->
<style>
	:global(:root) {
	--black: #141414;
	--white: #cccccc;
	--light-grey: #cacaca;
	--light-blue: #173370;
	/* --king-blue: #172074;
	--middle-blue: #0c113b; */
	--primary-clr: #222222;
	--secondary-clr: #181818;
	/* --light-gold: #b8b500;
	--orange: #be3c3c; */
	--contrast-clr-1: #009940;
	--contrast-clr-2: #aa002b;
	--box-shadow: 1px 1px 5px -1px rgba(0, 0, 0, 0.6);
	--font-size-items: 1.1rem;
}

	:global(*) {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
		border: none;
	}

	:global(body) {
		background-color: var(--light-grey);
		padding: 0;
	}

	:global(input, button, select, textarea) {
    font-family: inherit;
    font-size: inherit;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    border: 0;
    border-radius: 0;
	}
	:global(input:focus-visible) {
		outline: 0;
		border: none;
	}

	:global(li){
		text-decoration: none;
		list-style: none;
	}

	main {
		min-height: 100vh;
		width: 100%;
		text-align: center;
		padding: 2em 3em;
		margin: 0 auto;
		background: var(--secondary-clr);
	}

	#list-wrapper{
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 1.4rem;
		max-width: 900px;
		margin: 4rem auto;
		/* overflow-x: hidden; */
	}

	#submit-form{
		display: inline-flex;
		width: 100%;
		border-radius: 5px;
		margin-bottom: 3rem;
		overflow: hidden;
	}

	#item-input {
		background-color: var(--primary-clr);
		height: 100%;
		width: 92%;
		color: var(--contrast-clr-1);
		box-shadow: var(--box-shadow);
		padding: 0.675rem;
		font-size: var(--font-size-items);
	}
	#item-input::placeholder{
		color: #6d6d6d;
	}

	button {
		color: var(--white);
		font-size: var(--font-size-items);
		cursor: pointer;
	}

	#add-btn {
		height: 100%;
		width: 8%;
		background-color: var(--contrast-clr-2);
		box-shadow: var(--box-shadow);
		padding: 0.675rem;
	}
	@media (hover: hover) {
		button#add-btn:hover{
			background-color: var(--contrast-clr-2);
			filter: saturate(75%);
		}
	}

</style>